import styled from 'styled-components';

const Styles = styled.div`
.button {
    display: inline-block;
    position: relative;
    cursor: pointer;
    outline: none;
    white-space: nowrap;
    margin: 5px;
    padding: 8px 22px;
    font-size: 0.875rem;
    line-height: 24px;
    background-color: var(--color-primary);
    color: var(--color-light);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-shadow: 1px 1px 1px rgba(0,0,0,0.2);
    border-radius: 3px;
    transition: all .2s ease-in-out;
}

.button:hover {
	background-color: var(--color-primary-light);
	opacity: 0.9;
}
`

const Button = props => {
    const { caption, click } = props;
    return (
        <Styles>
            <div className="button" rel="3" onClick={click} >{caption} &rArr;</div>
        </Styles>
    )
}
export default Button;
